import { render, staticRenderFns } from "./login-sample.vue?vue&type=template&id=206391f4&"
import script from "./login-sample.vue?vue&type=script&lang=js&"
export * from "./login-sample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports